var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.527,
    height: 23.921,
    viewBox: "0 0 37.527 23.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    transform: "translate(-261.614 -1535.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M38,29.661V40.224l9.148-5.282Zm1.016,1.761,6.1,3.521-6.1,3.522Z",
    transform: "translate(238.422 1512.507)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M37.976,4.567H9.8c-2.577,0-4.673,1.639-4.673,3.655V24.833c0,2.015,2.1,3.655,4.673,3.655h28.18c2.577,0,4.673-1.64,4.673-3.655V8.222C42.65,6.207,40.554,4.567,37.976,4.567ZM41.8,24.833c0,1.649-1.715,2.99-3.824,2.99H9.8c-2.108,0-3.824-1.341-3.824-2.99V8.222c0-1.649,1.715-2.99,3.824-2.99h28.18c2.108,0,3.824,1.341,3.824,2.99V24.833Z",
    transform: "translate(256.491 1530.767)",
    fill: "#404040"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeTypeIcon);
export default __webpack_public_path__ + "static/media/youtubeTypeIcon.a8d00af25c468ec71da8bb0bfeb24612.svg";
export { ForwardRef as ReactComponent };